import { ChargingLocationDto } from '../dto'
import { ChargingLocationModel } from '../models'

/**
 * Transform ChargingLocationDto to ChargingLocationModel
 */
export const transformChargingLocationDtoToModel = (dto: ChargingLocationDto | null): ChargingLocationModel | null => {
  if (!dto) return null

  const { gpsLatitude, gpsLongitude } = dto

  const hasLatitude = gpsLatitude !== null || gpsLatitude !== undefined
  const hasLongitude = gpsLongitude !== null || gpsLongitude !== undefined

  const hasChargingLocation = hasLatitude && hasLongitude

  if (!hasChargingLocation) return null

  return {
    gpsLatitude: Number.parseFloat(dto.gpsLatitude),
    gpsLongitude: Number.parseFloat(dto.gpsLongitude),
  }
}
